import React from "react";

const AllGames = () => {
  return (
    <div>
      <h1>Todos los juegos de FortuneFlare</h1>
      <ul>
        <li>Slots</li>
        <li>BlackJack</li>
        <li>Ruleta</li>
      </ul>
    </div>
  );
};

export default AllGames;
